import { defineComponent as _defineComponent } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'LoadingSpinner',
    props: {
        message: { type: String, required: false }
    },
    setup(__props, { expose: __expose }) {
        __expose();
        const __returned__ = {};
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
